import InfantPassenger from '../../interfaces/server/InfantPassenger'

import dateFromBackEndToFrontendFormat from '../../utils/dates/dateFromBackEndToFrontendFormat'

export const dateOfBirth = (infantPassenger: InfantPassenger) =>
  dateFromBackEndToFrontendFormat(infantPassenger.dateOfBirth)

export default {
  id: 'id',
  dateOfBirth,
  firstName: 'firstName',
  lastName: 'lastName',
  gender: 'gender',
}
